import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
@Component({
	selector: 'topup-detail',
	template: require('./topupdetail.component.html'),
	styles: [require('./topupdetail.component.scss')]

})
export class TopupdetailComponent implements OnInit, OnChanges {

	display: boolean = true;

	array = [1, 2, 3];

	@Input('flag') data: any;

	@Output() event = new EventEmitter();

	constructor() {
	}


	ngOnChanges(changes: SimpleChanges): void {
		if (changes) {
			this.display = changes.data.currentValue;
		}
	}
	ngOnInit() {

	}

	show() {
		this.display = true;
	}

	handleCancel() {
		this.callback();
		this.display = false;
	}

	handleOk() {
		this.display = false;
	}

	callback = () => {
		this.event.emit(1);
	};

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/topupdetail/topupdetail.component.ts